export default __webpack_public_path__ + "57ad8d8fd6eaa38fcaf69ea59a193835.svg";